<template>
    <div class="v-spinner" v-show="loading">
        <div class="v-clip" v-bind:style="spinnerStyle"></div>
    </div>
</template>

<script>
/* eslint no-mixed-spaces-and-tabs: 'off', no-tabs: 'off' */
export default {
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            // default: '#5dc596',
            default: 'rgba(64, 64, 64, .35)'
        },
        altColor: {
            type: String,
            default: 'rgba(64, 64, 64, .8)'
        },
        size: {
            type: String,
            default: '60px'
        },
        radius: {
            type: String,
            default: '100%'
        }
    },
    computed: {
        spinnerStyle() {
            return {
                height: this.size,
                width: this.size,
                borderWidth: '6px',
                borderStyle: 'solid',
                borderColor:
                    this.color + ' ' + this.color + ' ' + this.altColor,
                borderRadius: this.radius,
                background: 'transparent'

                //         display: inline-block;
                // height: 45px;
                // width: 45px;
                // position: relative;
                // -webkit-animation: rotation .6s infinite linear;
                // -moz-animation: rotation .6s infinite linear;
                // -o-animation: rotation .6s infinite linear;
                // animation: rotation .6s infinite linear;
                // border-left: 6px solid rgba(64, 64, 64, .35);
                // border-right: 6px solid rgba(64, 64, 64, .35);
                // border-bottom: 6px solid rgba(64, 64, 64, .35);
                // border-top: 6px solid rgba(64, 64, 64, .8);
                // border-radius: 100%;
            };
        }
    }
};
</script>

<style>
.v-spinner {
    z-index: auto; /* Set to 30 if we want to protect the screen from changes during a load */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.v-spinner .v-clip {
    -webkit-animation: v-clipDelay 0.6s 0s infinite linear;
    animation: v-clipDelay 0.6s 0s infinite linear;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    /* Center on screen */
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    overflow: auto;
    height: auto;
}

@-webkit-keyframes v-clipDelay {
    0% {
        -webkit-transform: rotate(0deg) scale(1);
        transform: rotate(0deg) scale(1);
    }
    50% {
        -webkit-transform: rotate(180deg) scale(1);
        transform: rotate(180deg) scale(1);
    }
    100% {
        -webkit-transform: rotate(360deg) scale(1);
        transform: rotate(360deg) scale(1);
    }
}

@keyframes v-clipDelay {
    0% {
        -webkit-transform: rotate(0deg) scale(1);
        transform: rotate(0deg) scale(1);
    }
    50% {
        -webkit-transform: rotate(180deg) scale(1);
        transform: rotate(180deg) scale(1);
    }
    100% {
        -webkit-transform: rotate(360deg) scale(1);
        transform: rotate(360deg) scale(1);
    }
}
</style>
